import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {SComponent} from "../header/header.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent extends SComponent {

  constructor() {
    super();
  }

}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/home/home.component.ts